export default "__VITE_ASSET__c11a0700__"